// export const BaseGatewayImage = 'https://localhost:5001';
// export const BaseGateway = 'https://localhost:5001/api/v1';
// export const BaseGatewayDomain = 'https://localhost:3000';

// export const BaseGatewayAuthApi = 'https://localhost:5003/api/v1';
// export const BaseGatewayAuth = 'https://localhost:5003';
// export const BaseGatewayAuthImage = 'https://localhost:5003';
// export const BaseGatewayCommon = 'https://localhost:4999/api/v1';

// export const BaseGatewayImage = 'https://api.testapp.cntt108.vn';
// export const BaseGateway = 'https://api.testapp.cntt108.vn/api/v1';
// export const BaseGatewayDomain = 'https://testapp.cntt108.vn';

export const BaseGatewayImage = 'https://api.huanluyendaotao.cntt108.vn';
export const BaseGateway = 'https://api.huanluyendaotao.cntt108.vn/api/v1';
export const BaseGatewayDomain = 'https://huanluyendaotao.cntt108.vn';

export const BaseGatewayAuthApi = 'https://api.authservice.cntt108.vn/api/v1';
export const BaseGatewayAuth = 'https://api.authservice.cntt108.vn';
export const BaseGatewayAuthImage = 'https://api.authservice.cntt108.vn';
export const BaseGatewayCommon = 'https://api.corehub.cntt108.vn/api/v1';

// export const BaseGatewayImage = 'http://localhost:5000';
// const BaseGateway = 'http://localhost:5000/api/v1';


// export const BaseGatewayImageAuth = 'http://localhost:5002';
// const BaseGatewayAuth = 'http://localhost:5002';

export const BaseGatewayNest = 'http://localhost:8080';

const BaseGatewayFromMainServer = 'http://108.108.108.52:10808';

export const BaseGatewayClient = 'http://interbgc.com.vn'

const BaseGatewayCrawler = 'http://crawlerapi.xecong.info';
// api chung lấy nguộn 
export const AUTH_API = {
    LOGIN_API: `${BaseGatewayAuth}/connect/token`,
    REFRESHTOKEN_API: `${BaseGatewayAuth}/connect/token`,
    CHANGE_PASSWORD_API: `${BaseGatewayAuthApi}/Account/ChangePassword`,
    FORGOT_PASSWORD: `${BaseGatewayAuth}/Auth/ForgotPassword`,
    RESET_PASSWORD: `${BaseGatewayAuth}/Auth/ResetPassword`
};

export const ACCOUNT_API = {
    GET_PAGING_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetAllPaging`,
    ADD_ACCOUNT: `${BaseGatewayAuthApi}/Account/Create`,
    ADD_ROLE_TO_ACCOUNT: `${BaseGatewayAuthApi}/Account/AddRoleToAccount`,
    RESET_ROLE_TO_ACCOUNT: `${BaseGatewayAuthApi}/Account/ResetRoleToAccount`,
    EDIT_ACCOUNT: `${BaseGatewayAuthApi}/Account/Update`,
    DELETE_ACCOUNT: `${BaseGatewayAuthApi}/Account/DeleteItem`,
    GET_BY_ID_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetItem`,
    COUNT_ALL_ACCOUNT_API: `${BaseGatewayAuthApi}/Account/CountAllAccount`,
    GET_ACCOUNT_INFO: `${BaseGateway}/AccountInfo/GetAccountInfo`,
    GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG: `${BaseGatewayCommon}/AccountInfo/SelectAccountInfoByAccountId`,
    GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG: `${BaseGatewayAuthApi}/AccountAuthInfo/GetItem`,
    GET_PAGING_ACCOUNT_FROM_APP_DUNGCHUNG: `${BaseGatewayCommon}/AccountInfo/GetAllByPaging`
};

export const ACCOUNT_AUTHINFO_API = {
    GET_PAGING: `${BaseGatewayAuthApi}/AccountAuthInfo/GetAllByPaging`,
    GET_BY_ID_ACCOUNT: `${BaseGatewayAuthApi}/AccountAuthInfo/GetItem`,
    GET_BY_USERNAME: `${BaseGatewayAuthApi}/AccountAuthInfo/GetAccountAuthInfoByUsername`,
};

export const OPENIDDICTAPPLICATION_API = {
    GET_PAGING: `${BaseGatewayAuthApi}/OpeniddictApplication/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/DeleteItem`
};

// export const FILE_MANAGER_API = {
//     UPLOAD: `${BaseGatewayAuthApi}/FileManager/Upload`,
//     GET_PAGING: `${BaseGatewayAuthApi}/FileManager/GetAllPaging`,
//     GET_DIR_PATH: `${BaseGatewayAuthApi}/FileManager/GetDirectoryPath`,
//     DELETE: `${BaseGatewayAuthApi}/FileManager`
// };

export const FILE_MANAGER_API = {
    UPLOAD: `${BaseGateway}/FileManager/Upload`,
    UPLOAD_INPUT_FILE: `/api/v1/FileManager/Upload`,
    GET_PAGING: `${BaseGateway}/FileManager/GetAllPaging`,
    GET_DIR_PATH: `${BaseGateway}/FileManager/GetDirectoryPath`,
    DELETE: `${BaseGateway}/FileManager/Delete`,
    DELETE_FILE_PATH: `${BaseGateway}/FileManager/DeleteFilePath`,
};

export const EMAILCONFIG_API = {
    GET_PAGING_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetAllByPaging`,
    GET_ITEM_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetItem`,
    ADD_EMAILCONFIG: `${BaseGateway}/EmailConfig/CreateEmailConfig`,
    UPDATE_EMAILCONFIG: `${BaseGateway}/EmailConfig/UpdateItem`,
    DELETE_EMAILCONFIG: `${BaseGateway}/EmailConfig/DeleteItem`
};

export const LOGIN_HISTORY_API = {
    GET_PAGING_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetAllPaging`,
    STATISTIC_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetStatisticsLoginByAccount`,
    STATISTIC_COUNT_LOGIN_BY_DATE: `${BaseGatewayAuth}/LoginHistory/CountAllByDate`
};

export const LOG_API = {
    GET_PAGING_LOG: `${BaseGateway}/Log/GetAllByPaging`,
    DELETE_LOG: `${BaseGateway}/Log/DeleteByDate`,
    COUNT_LOG_BY_DATE: `${BaseGateway}/Log/CountLogsByDate`,
};


// export const APIROLEMAPPING_API = {
//     GET_PAGING: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPaging`,
//     GET_PAGING_NOT_MENU: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPagingNotMenu`,
//     GET_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/GetItem`,
//     ADD_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/Create`,
//     UPDATE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/UpdateItem`,
//     DELETE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/DeleteItem`,
//     BULK_ASSIGN_ROLES: `${BaseGatewayAuthApi}/ApiRoleMapping/BulkAssignRoles`
// };

// export const APIROLEMAPPING_API = {
//     GET_PAGING: `${BaseGatewayCommon}/ApiRoleMapping/GetAllByPaging`,
//     GET_PAGING_NOT_MENU: `${BaseGateway}/ApiRoleMapping/GetAllByPagingNotMenu`,
//     GET_ITEM: `${BaseGatewayCommon}/ApiRoleMapping/GetItem`,
//     ADD_ITEM: `${BaseGatewayCommon}/ApiRoleMapping/Create`,
//     UPDATE_ITEM: `${BaseGatewayCommon}/ApiRoleMapping/UpdateItem`,
//     DELETE_ITEM: `${BaseGatewayCommon}/ApiRoleMapping/DeleteItem`,
//     BULK_ASSIGN_ROLES: `${BaseGatewayCommon}/ApiRoleMapping/BulkAssignRoles`
// };

export const APIROLEMAPPING_API = {
    GET_PAGING: `${BaseGateway}/ApiRoleMapping/GetAllByPaging`,
    GET_PAGING_NOT_MENU: `${BaseGateway}/ApiRoleMapping/GetAllByPagingNotMenu`,
    GET_ITEM: `${BaseGateway}/ApiRoleMapping/GetItem`,
    ADD_ITEM: `${BaseGateway}/ApiRoleMapping/Create`,
    UPDATE_ITEM: `${BaseGateway}/ApiRoleMapping/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ApiRoleMapping/DeleteItem`,
    BULK_ASSIGN_ROLES: `${BaseGateway}/ApiRoleMapping/BulkAssignRoles`
};

export const ROLE_API = {
    GET_ALL: `${BaseGatewayAuthApi}/Role/GetAll`,
    GET_PAGING: `${BaseGatewayAuthApi}/Role/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/Role/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/Role/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/Role/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/Role/DeleteItem`,
    UPDATE_TREE: `${BaseGatewayAuthApi}/Role/UpdateTree`
};

export const MENU_API = {
    GET_PAGING: `${BaseGateway}/MenuItem/GetAllByPaging`,
    GET_MENU: `${BaseGateway}/MenuItem/GetMenu`,
    GET_ITEM: `${BaseGateway}/MenuItem/GetItem`,
    ADD_ITEM: `${BaseGateway}/MenuItem/Create`,
    UPDATE_ITEM: `${BaseGateway}/MenuItem/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MenuItem/DeleteItem`,
    UPDATE_TREE: `${BaseGateway}/MenuItem/UpdateTree`
};

export const KYSO_API = {
    KYSO: `${BaseGateway}/KySo/AuthorizeKySo`,
    KYSO_ONE_FILE_ONE_SIGNATURE: `${BaseGateway}/KySo/AuthorizeKySoOneFileOneSignature`,
};

export const SIGNEDHUMAN_API = {
    GET_PAGING: `${BaseGateway}/SignedHuman/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/SignedHuman/GetItem`,
    ADD_ITEM: `${BaseGateway}/SignedHuman/Create`,
    UPDATE_ITEM: `${BaseGateway}/SignedHuman/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/SignedHuman/DeleteItem`,
    EXPORT_USERS_PDF: `${BaseGateway}/SignedHuman/ExportPdfListUser`,
    EXPORT_PDF: `${BaseGateway}/SignedHuman/ExportPdfToSign`,
    // EXPORT_USERS_PDF: `${BaseGateway}/SignedHuman/ExportPdf`,
    // EXPORT_USERS_PDF: `${BaseGateway}/SignedHuman/FillPdf`,
    // EXPORT_USERS_PDF: `${BaseGatewayNest}/export-pdf`,
};

export const CHUDE_API = {
    GET_PAGING: `${BaseGateway}/ChuDe/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChuDe/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChuDe/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChuDe/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChuDe/DeleteItem`,
};

export const DANHMUCPHANMEM_API = {
    GET_PAGING: `${BaseGateway}/DanhMucPhanMem/GetAllByPaging`,
    GET_PAGING_SHOW: `${BaseGateway}/DanhMucPhanMem/GetAllByPagingShow`,
    GET_ITEM: `${BaseGateway}/DanhMucPhanMem/GetItem`,
    ADD_ITEM: `${BaseGateway}/DanhMucPhanMem/Create`,
    UPDATE_ITEM: `${BaseGateway}/DanhMucPhanMem/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DanhMucPhanMem/DeleteItem`,
};

export const CHUONGTRINHHOC_API = {
    GET_PAGING: `${BaseGateway}/ChuongTrinhHoc/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChuongTrinhHoc/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChuongTrinhHoc/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChuongTrinhHoc/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChuongTrinhHoc/DeleteItem`,
};

export const NGANH_API = {
    GET_PAGING: `${BaseGateway}/Nganh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/Nganh/GetItem`,
    ADD_ITEM: `${BaseGateway}/Nganh/Create`,
    UPDATE_ITEM: `${BaseGateway}/Nganh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/Nganh/DeleteItem`,
};

export const NHOMTIEUCHI_API = {
    GET_PAGING: `${BaseGateway}/NhomTieuChi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/NhomTieuChi/GetItem`,
    ADD_ITEM: `${BaseGateway}/NhomTieuChi/Create`,
    UPDATE_ITEM: `${BaseGateway}/NhomTieuChi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/NhomTieuChi/DeleteItem`,
};

export const TIEUCHI_API = {
    GET_PAGING: `${BaseGateway}/TieuChi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/TieuChi/GetItem`,
    ADD_ITEM: `${BaseGateway}/TieuChi/Create`,
    UPDATE_ITEM: `${BaseGateway}/TieuChi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/TieuChi/DeleteItem`,
};

export const MUCDANHGIA_API = {
    GET_PAGING: `${BaseGateway}/MucDanhGia/GetAllByPaging`,
    CREATE_ITEM: `${BaseGateway}/MucDanhGia/Create`,
    UPDATE_ITEM: `${BaseGateway}/MucDanhGia/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MucDanhGia/DeleteItem`,
    GET_ITEM: `${BaseGateway}/MucDanhGia/GetItem`
};

export const CHITIETKETQUANCS_API = {
    GET_PAGING: `${BaseGateway}/ChiTietKetQuaNCS/GetAllByPaging`,
    CREATE_ITEM: `${BaseGateway}/ChiTietKetQuaNCS/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChiTietKetQuaNCS/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChiTietKetQuaNCS/DeleteItem`,
    GET_ITEM: `${BaseGateway}/ChiTietKetQuaNCS/GetItem`
};

export const CHUYENNGANH_API = {
    GET_PAGING: `${BaseGateway}/ChuyenNganh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChuyenNganh/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChuyenNganh/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChuyenNganh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChuyenNganh/DeleteItem`,
};

export const DANHMUCVANBANGCHUNGCHI_API = {
    GET_PAGING: `${BaseGateway}/DanhMucVanBangChungChi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DanhMucVanBangChungChi/GetItem`,
    ADD_ITEM: `${BaseGateway}/DanhMucVanBangChungChi/Create`,
    UPDATE_ITEM: `${BaseGateway}/DanhMucVanBangChungChi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DanhMucVanBangChungChi/DeleteItem`,
};

export const DOTTUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/DotTuyenSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DotTuyenSinh/GetItem`,
    ADD_ITEM: `${BaseGateway}/DotTuyenSinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/DotTuyenSinh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DotTuyenSinh/DeleteItem`,
};

export const DANGKY_DOTTUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/DangKyDotTuyenSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DangKyDotTuyenSinh/GetItem`,
};

export const HOSO_TUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/HoSoTuyenSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HoSoTuyenSinh/GetItem`,
    ADD_ITEM: `${BaseGateway}/HoSoTuyenSinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/HoSoTuyenSinh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/HoSoTuyenSinh/DeleteItem`,
};

export const DUYET_HOSO_TUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/DuyetHoSoTuyenSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DuyetHoSoTuyenSinh/GetItem`,
    DUYET_HO_SO: `${BaseGateway}/DuyetHoSoTuyenSinh/DuyetHoSo`,
};

export const LYLICHKHOAHOC_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/LyLichKhoaHoc/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/LyLichKhoaHoc/Create`,
    UPDATE_ITEM: `${BaseGateway}/LyLichKhoaHoc/Update`,
};

export const MINHCHUNGKHOAHOC_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/MinhChungKhoaHoc/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/MinhChungKhoaHoc/Create`,
    UPDATE_ITEM: `${BaseGateway}/MinhChungKhoaHoc/Update`,
};

export const DECUONGNGHIENCUU_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/DeCuongNghienCuu/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/DeCuongNghienCuu/Create`,
    UPDATE_ITEM: `${BaseGateway}/DeCuongNghienCuu/Update`,
};

export const VANBANGTUYENSINH_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/VanBangTuyenSinh/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/VanBangTuyenSinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/VanBangTuyenSinh/Update`,
    DELETE_ITEM: `${BaseGateway}/VanBangTuyenSinh/Delete`,
};

export const VANBANGDAIHOC_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/VanBangDaiHoc/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/VanBangDaiHoc/Create`,
    UPDATE_ITEM: `${BaseGateway}/VanBangDaiHoc/Update`,
    DELETE_ITEM: `${BaseGateway}/VanBangDaiHoc/Delete`,
};

export const VANBANGCHUNGCHINGOAINGU_API = {
    GET_BY_HOSO_ID: `${BaseGateway}/VanBangChungChiNgoaiNgu/GetByHoSoTuyenSinhId`,
    ADD_ITEM: `${BaseGateway}/VanBangChungChiNgoaiNgu/Create`,
    UPDATE_ITEM: `${BaseGateway}/VanBangChungChiNgoaiNgu/Update`,
    DELETE_ITEM: `${BaseGateway}/VanBangChungChiNgoaiNgu/Delete`,
};


export const DANGKYDUTUYEN_API = {
    GET_PAGING: `${BaseGateway}/DangKyDuTuyen/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DangKyDuTuyen/GetItem`,
    ADD_ITEM: `${BaseGateway}/DangKyDuTuyen/Create`,
    UPDATE_ITEM: `${BaseGateway}/DangKyDuTuyen/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DangKyDuTuyen/DeleteItem`,
};

export const CME_ADMIN_API = {
    GET_CATEGORIES: `${BaseGateway}/CMEAdmin/ConfigCategories`,
    GET_CATEGORY_ITEM: `${BaseGateway}/CMEAdmin/ConfigCategoryById`, // sẽ + /{id}
    ADD_UPDATE_CATEGORY: `${BaseGateway}/CMEAdmin/ConfigCategory`,
    DELETE_CATEGORY: `${BaseGateway}/CMEAdmin/DeleteCategory`, // sẽ + /{id}
    GET_RULE_ITEM: `${BaseGateway}/CMEAdmin/ConfigRuleById`, // sẽ + /{id}
    ADD_UPDATE_RULE: `${BaseGateway}/CMEAdmin/ConfigRule`,
    DELETE_RULE: `${BaseGateway}/CMEAdmin/DeleteRule`, // sẽ + /{id}
    GET_ALL_HO_SO: `${BaseGateway}/CMEAdmin/HoSoPaging`,
    DUYET_HO_SO: `${BaseGateway}/CMEAdmin/ApproveHoSo`,
    GET_CME_VAITRO: `${BaseGateway}/CMEAdmin/GetVaiTros`,
    GET_CME_DONVITINH: `${BaseGateway}/CMEAdmin/GetDonViTinhs`,
    UPSERT_CME_VAITRO: `${BaseGateway}/CMEAdmin/UpsertVaiTro`,
    UPSERT_CME_DONVITINH: `${BaseGateway}/CMEAdmin/UpsertDonViTinh`,
    DELETE_CME_VAITRO: `${BaseGateway}/CMEAdmin/DeleteVaiTro`, // sẽ + /{id}
    DELETE_CME_DONVITINH: `${BaseGateway}/CMEAdmin/DeleteDonViTinh`, // sẽ + /{id}
};

export const CME_KHOA_DAO_TAO_API = {
    GET_ALL: `${BaseGateway}/CMEKhoaDaoTao/GetAll`,
    GET_PAGING: `${BaseGateway}/CMEKhoaDaoTao/GetPaging`,
    GET_BY_ID: `${BaseGateway}/CMEKhoaDaoTao/GetById`, // + /{id}
    UPSERT: `${BaseGateway}/CMEKhoaDaoTao/Upsert`,
    DELETE: `${BaseGateway}/CMEKhoaDaoTao/Delete`, // + /{id}
    PREVIEW_IMPORT: `${BaseGateway}/CMEKhoaDaoTao/PreviewImport`, // + /{eventId}
    CONFIRM_IMPORT: `${BaseGateway}/CMEKhoaDaoTao/ConfirmImport`, // + /{eventId}
    LOCK_EVENT: `${BaseGateway}/CMEKhoaDaoTao/LockEvent`, // + /{id}
    GET_PARTICIPANTS: `${BaseGateway}/CMEKhoaDaoTao/GetParticipants`, // + /{eventId}
};

export const CME_DIEU_DUONG_API = {
    GET_ALL: `${BaseGateway}/CMEDieuDuongUser/GetAll`,
    GET_BY_ID: `${BaseGateway}/CMEDieuDuongAdmin/GetById`, // + /{id}
    UPSERT: `${BaseGateway}/CMEDieuDuongAdmin/Upsert`,
    DELETE: `${BaseGateway}/CMEDieuDuongAdmin/Delete`, // + /{id}
    TOGGLE_CHECKIN: `${BaseGateway}/CMEDieuDuongAdmin/ToggleDiemDanhBatDau`, // + /{id}
    TOGGLE_CHECKOUT: `${BaseGateway}/CMEDieuDuongAdmin/ToggleDiemDanhKetThuc`, // + /{id}
    CHECKIN: `${BaseGateway}/CMEDieuDuongUser/DiemDanhBatDau`, // + /{eventId}
    CHECKOUT: `${BaseGateway}/CMEDieuDuongUser/DiemDanhKetThuc`, // + /{eventId}
    GET_ATTENDANCE: `${BaseGateway}/CMEDieuDuongAdmin/GetDiemDanhList`, // + /{eventId}
    SAVE_LIST: `${BaseGateway}/CMEDieuDuongAdmin/LuuDanhSach`, // + /{eventId}
    APPROVE_STEP1: `${BaseGateway}/CMEDieuDuongAdmin/DuyetBuoc1`, // + /{eventId}
    SAVE_PHU_LUC_2_FILE_STATE: `${BaseGateway}/CMEDieuDuongAdmin/SavePhuLuc2FileState`, // + /{eventId}
    RESET_PHU_LUC_2_FILE_STATE: `${BaseGateway}/CMEDieuDuongAdmin/ResetPhuLuc2FileState`, // + /{eventId}
    APPROVE_STEP2: `${BaseGateway}/CMEDieuDuongDuyet/DuyetBuoc2`,
    GET_STEP2_PAGING: `${BaseGateway}/CMEDieuDuongDuyet/GetDuyetBuoc2Paging`,
    GET_PAGING: `${BaseGateway}/CMEDieuDuongAdmin/GetPaging`,
};

export const CME_USER_API = {
    GET_CATEGORIES: `${BaseGateway}/CMEUser/UserCategories`,
    GET_RULES: `${BaseGateway}/CMEUser/UserRules`, // sẽ + /{categoryId}
    GET_MY_HO_SO: `${BaseGateway}/CMEUser/UserPaging`,
    POST_USER_PAGING: `${BaseGateway}/CMEUser/UserPaging`,
    GET_BY_ID: `${BaseGateway}/CMEUser/UserHoSoById`, // sẽ + /{id}
    SUBMIT_HO_SO: `${BaseGateway}/CMEUser/UserSubmit`,
    DELETE_HO_SO: `${BaseGateway}/CMEUser/UserDelete`, // sẽ + /{id}
    POST_USER_CLONE: `${BaseGateway}/CMEUser/UserClone`,
    GET_MY_SUMMARY: `${BaseGateway}/CMEUser/UserSummary`,
};

export const PHAMVIHANHNGHE_API = {
    GET_PAGING: `${BaseGateway}/PhamViHanhNghe/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/PhamViHanhNghe/GetItem`,
    ADD_ITEM: `${BaseGateway}/PhamViHanhNghe/Create`,
    UPDATE_ITEM: `${BaseGateway}/PhamViHanhNghe/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/PhamViHanhNghe/DeleteItem`,
};


export const ACCOUNTINFO_API = {
    GET_PAGING: `${BaseGateway}/AccountInfo/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/AccountInfo/GetItem`,
    ADD_ITEM: `${BaseGateway}/AccountInfo/Create`,
    UPDATE_ITEM: `${BaseGateway}/AccountInfo/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/AccountInfo/DeleteItem`,
    GET_BY_ACCOUNT_ID: `${BaseGateway}/AccountInfo/GetByAccountId`,
    GET_BY_ID_ACCOUNT: `${BaseGateway}/AccountInfo/SelectAccountInfoByAccountId`,
};

export const GIAYPHEPHANHNGHE_API = {
    GET_PAGING: `${BaseGateway}/GiayPhepHanhNghe/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/GiayPhepHanhNghe/GetItem`,
    ADD_ITEM: `${BaseGateway}/GiayPhepHanhNghe/Create`,
    UPDATE_ITEM: `${BaseGateway}/GiayPhepHanhNghe/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/GiayPhepHanhNghe/DeleteItem`,
    UPDATE_FIELD: `${BaseGateway}/GiayPhepHanhNghe/UpdateField`,
    GET_ACCOUNT_INFO_ID: `${BaseGateway}/GiayPhepHanhNghe/GetByAccountInfoId`,
    GET_ALL: `${BaseGateway}/GiayPhepHanhNghe/GetAll`,
    GET_BY_GIAYPHEP_ID: `${BaseGateway}/GiayPhepHanhNghe/GetByGiayPhepHanhNgheId`,
    UPDATE_FIELD_DSDHS: `${BaseGateway}/GiayPhepHanhNghe/UpdateFieldDSDHS`,
    GET_PAGING_PHAMVIHANHNGHE: `${BaseGateway}/GiayPhepHanhNghe/GetAllByPagingPhamViHanhNghe`,
    GET_ALL_BY_PAGING_DANHMUCVANBANGCHUNGCHI: `${BaseGateway}/GiayPhepHanhNghe/GetAllByPagingDanhMucVanBangChungChi`

};

export const CHUNGCHI_CHUYENMON_API = {
    GET_PAGING: `${BaseGateway}/ChungChiChuyenMon/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChungChiChuyenMon/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChungChiChuyenMon/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChungChiChuyenMon/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChungChiChuyenMon/DeleteItem`,
    GET_BY_ACCOUNT_INFO_ID: `${BaseGateway}/ChungChiChuyenMon/GetByAccountInfoId`,
    UPDATE_LIST: `${BaseGateway}/ChungChiChuyenMon/UpdateList`,
    UPDATE_FIELD: `${BaseGateway}/ChungChiChuyenMon/UpdateField`
};
export const DONGPHIPHUC_API = {
    ADD_ITEM: `${BaseGateway}/DongPhiPhucKhao/Create`,
    UPDATE_ITEM: `${BaseGateway}/DongPhiPhucKhao/UpdateItem`,
    GET_BY_HOSO: `${BaseGateway}/DongPhiPhucKhao/GetByHoSoId`,
    GET_ALL_PAGING: `${BaseGateway}/DongPhiPhucKhao/GetAllPaging`
};

export const TRINHDO_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/TrinhDo/GetAllByPaging`
};

export const QUOCGIA_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/QuocGia/GetAllByPaging`
};

export const DONVIDAOTAO_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/DonViDaoTao/GetAllByPaging`
};

export const HINHTHUCDAOTAO_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/HinhThucDaoTao/GetAllByPaging`
};

export const XEPLOAIDAOTAO_API = {
    GET_ALL_PAGING: `${BaseGatewayCommon}/XepLoaiDaoTao/GetAllByPaging`
};

export const DANHSACH_DUYET_HOSO_API = {
    ADD_ITEM: `${BaseGateway}/DanhSachDuyetHoSo/Create`,
    UPDATE_FIELD: `${BaseGateway}/DanhSachDuyetHoSo/UpdateField`,
    GET_BY_GIAYPHEP_ID: `${BaseGateway}/DanhSachDuyetHoSo/GetByGiayPhepHanhNgheId`,
    GET_ALL_BY_PAGING_GIAYPHEPHANHNGHE: `${BaseGateway}/DanhSachDuyetHoSo/GetAllByPagingGiayPhepHanhNghe`,
    GET_ALL_BY_PAGING: `${BaseGateway}/DanhSachDuyetHoSo/GetAllPaging`,
    UPDATE_FIELD_GPHN: `${BaseGateway}/DanhSachDuyetHoSo/UpdateFieldGPHN`,
    UPDATE_FIELD_CCCM: `${BaseGateway}/DanhSachDuyetHoSo/UpdateFieldCCCM`,
    GET_THONGKE_GPHN: `${BaseGateway}/DanhSachDuyetHoSo/GetThongKeGPHN`
};

export const DONVI_API = {
    GET_PAGING: `${BaseGatewayCommon}/DonVi/GetAllByPaging`,
};

export const CHUCVU_API = {
    GET_PAGING: `${BaseGatewayCommon}/ChucVu/GetAllByPaging`,
};

export const DOITUONG_API = {
    GET_PAGING: `${BaseGatewayCommon}/DoiTuong/GetAllByPaging`,
};

export const CHUYENMON_API = {
    GET_PAGING: `${BaseGatewayCommon}/ChuyenMon/GetAllByPaging`,
};

export const ADDRESS_API = {
    GET_PROVINCES: `${BaseGateway}/AddressProxy/GetProvinces`,
    GET_WARDS: `${BaseGateway}/AddressProxy/GetWards`,
};

export const VANBANG_API = {
    GET_PAGING: `${BaseGateway}/VanBang/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/VanBang/GetItem`,
    ADD_ITEM: `${BaseGateway}/VanBang/Create`,
    UPDATE_ITEM: `${BaseGateway}/VanBang/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/VanBang/DeleteItem`,
    UPDATE_FIELD: `${BaseGateway}/VanBang/UpdateField`,
    GET_BY_ACCOUNT_ID: `${BaseGateway}/VanBang/GetByAccountId`,
};

export const CHUNGCHINGOAINGU_API = {
    GET_PAGING: `${BaseGateway}/ChungChiNgoaiNgu/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChungChiNgoaiNgu/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChungChiNgoaiNgu/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChungChiNgoaiNgu/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChungChiNgoaiNgu/DeleteItem`,
    UPDATE_FIELD: `${BaseGateway}/ChungChiNgoaiNgu/UpdateField`,
    GET_BY_ACCOUNT_ID: `${BaseGateway}/ChungChiNgoaiNgu/GetByAccountId`,
};

export const DANHSACH_DUYET_NGOAINGU_API = {
    UPDATE_FIELD_VAN_BANG: `${BaseGateway}/DanhSachDuyetNgoaiNgu/UpdateFieldVanBang`,
    UPDATE_FIELD_CHUNG_CHI_NGOAI_NGU: `${BaseGateway}/DanhSachDuyetNgoaiNgu/UpdateFieldChungChiNgoaiNgu`,
    GET_ALL_VANBANG_BY_PAGING: `${BaseGateway}/DanhSachDuyetNgoaiNgu/GetAllVanBangByPaging`,
    GET_ALL_CHUNGCHINGOAINGU_BY_PAGING: `${BaseGateway}/DanhSachDuyetNgoaiNgu/GetAllChungChiNgoaiNguByPaging`,
    GET_THONGKE_NGOAINGU: `${BaseGateway}/DanhSachDuyetNgoaiNgu/GetThongKeNgoaiNgu`
};

export const KETQUATUYENSINH_API = {
    GET_PAGING: `${BaseGateway}/KetQuaTuyenSinh/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/KetQuaTuyenSinh/GetItem`,
    CREATE_ITEM: `${BaseGateway}/KetQuaTuyenSinh/Create`,
    UPDATE_ITEM: `${BaseGateway}/KetQuaTuyenSinh/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/KetQuaTuyenSinh/DeleteItem`
};
